module.exports = __webpack_public_path__ + "static/share-531d56663561d18af8bf1605fce6daeb.mp4";